module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flights.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, _vm._l((_vm.flights), function(flight) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(flight.flightType) + "vlucht | " + _vm._s(flight.departureCity) + " - " + _vm._s(flight.arrivalCity))])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-4 col-lg-4"
    }, [_c('label', [_vm._v("Vluchtnummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(flight.flightnumber))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4 col-lg-4"
    }, [_c('label', [_vm._v("Vertrek")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(flight.dateRanges[0].startDate) + " "), (flight.dateRanges[0].startTime != '00:00') ? _c('span', [_vm._v(_vm._s(flight.dateRanges[0].startTime))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4 col-lg-4"
    }, [_c('label', [_vm._v("Aankomst")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(flight.dateRanges[0].endDate) + " "), (flight.dateRanges[0].endTime != '00:00') ? _c('span', [_vm._v(_vm._s(flight.dateRanges[0].endTime))]) : _vm._e()])])])])])
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Vluchten\r\n          "), _c('i', {
    staticClass: "fa fa-plane pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddc4478a"}!./src/templates/reservations/flights-view.html
// module id = 553
// module chunks = 1